
export default {
  getLogsNiceenergie: (fromDate, toDate) => {
    return {
      url: '/logs/env/:env',
      method: 'GET',
      route_params: {
        env: 'niceenergie'
      },
      get_params: {
        fromDate,
        toDate
      }
    };
  }
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsNiceenergie/api.js